<template>
  <div>
    <can action="view" subject="company">
      <div class="ibox-title">
        <h5>Company Details</h5>
        <can action="edit" subject="company-details">
          <div class="ibox-tools">
            <el-tooltip class="item" content="Edit" placement="left">
              <el-button
                type="primary"
                size="small"
                class="ibox-tool-btn"
                @click="dialogVisible = !dialogVisible"
                plain
              >
                <i class="fa fa-pencil"></i>
              </el-button>
            </el-tooltip>
          </div>
        </can>
      </div>
      <div class="ibox-content ibox-heading">
        Contact, location and other various details related to my station.
      </div>
      <div class="ibox-content" v-loading="!company">
        <div v-if="company && company.logoImage" class="company-logo">
          <img v-if="company.logoImage" :src="company.logoImage" />
          <hr v-if="company.logoImage" />
        </div>
        <div v-if="company">
          <div v-if="company.title" class="row p-xs">
            <div class="col-md-5">
              <strong>Title:</strong>
            </div>
            <div class="col-md-7">{{ company.title }}</div>
          </div>

          <div v-if="company.webSite" class="row p-xs">
            <div class="col-md-5">
              <strong>Website:</strong>
            </div>
            <div class="col-md-7">
              <a :href="company.webSite" target="_blank">{{ company.webSite }}</a>
            </div>

            <div v-if="company.telephoneNumber" class="row p-xs">
              <div class="col-md-5">
                <strong>Telephone no:</strong>
              </div>
              <div class="col-md-7">{{ company.telephoneNumber }}</div>
            </div>

            <div v-if="company.faxNumber" class="row p-xs">
              <div class="col-md-5">
                <strong>Fax no:</strong>
              </div>
              <div class="col-md-7">{{ company.faxNumber }}</div>
            </div>

            <div v-if="company.timezone" class="row p-xs">
              <div class="col-md-5">
                <strong>Timezone:</strong>
              </div>
              <div class="col-md-7">{{ company.timezone }}</div>
            </div>

            <div v-if="company.woeid" class="row p-xs">
              <div class="col-md-5">
                <strong>WOEID:</strong>
              </div>
              <div class="col-md-7">{{ company.woeid }}</div>
            </div>

            <div v-if="company.cumulativeAudience" class="row p-xs">
              <div class="col-md-5">
                <strong>Cume:</strong>
              </div>
              <div class="col-md-7">{{ company.cumulativeAudience.toLocaleString() }}</div>
            </div>
            <br v-else />
          </div>
        </div>
      </div>
    </can>
    <el-dialog title="Edit Company" :visible.sync="dialogVisible" size="small" v-if="company">
      <el-form label-position="left" label-width="150px" :model="company">
        <el-form-item label="Title" prop="title">
          <el-input v-model="company.title" placeholder="Title"></el-input>
        </el-form-item>

        <el-form-item label="Short Name" prop="short_name">
          <el-input v-model="company.shortName" placeholder="Short Name"></el-input>
        </el-form-item>

        <el-form-item label="Website" prop="webSite">
          <el-input v-model="company.webSite" placeholder="Website"></el-input>
        </el-form-item>

        <el-form-item label="Format" prop="format">
          <el-input v-model="company.format" placeholder="Format"></el-input>
        </el-form-item>

        <el-form-item label="Genre" prop="genre">
          <el-input v-model="company.genre" placeholder="Genre"></el-input>
        </el-form-item>

        <el-form-item label="Telephone no." prop="telephoneNumber">
          <el-input v-model="company.telephoneNumber" placeholder="Telephone no."></el-input>
        </el-form-item>

        <el-form-item label="Fax no." prop="faxNumber">
          <el-input v-model="company.faxNumber" placeholder="Fax no."></el-input>
        </el-form-item>

        <el-form-item label="Country" prop="country">
          <el-select
            class="full-width"
            v-model="company.country"
            placeholder="Select Country"
            filterable
            @change="handleCountryChange"
          >
            <el-option
              v-for="(country, index) in countries"
              :key="index"
              :label="country.name"
              :value="country.alpha2"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="State" prop="state">
          <el-select
            class="full-width"
            v-model="company.state"
            placeholder="Select State"
            :disabled="regions.length === 0"
            filterable
          >
            <el-option
              v-for="(region, index) in regions"
              :key="index"
              :label="region.name"
              :value="region.name"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="Timezone" prop="timezone">
          <el-select
            class="full-width"
            v-model="company.timezone"
            placeholder="Select Timezone"
            :loading="loadingTimezones"
            filterable
          >
            <el-option
              v-for="(timezone, index) in timezones"
              :key="index"
              :label="timezone[1]"
              :value="timezone[0]"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="WOEID" prop="woeid">
          <el-input v-model="company.woeid" placeholder="WOEID"></el-input>
        </el-form-item>
        <el-form-item label="Cume" prop="cume">
          <el-input v-model="company.cumulativeAudience" placeholder="Cume"></el-input>
        </el-form-item>
        <el-form-item label="Station Logo">
          <el-upload
            action="https://jsonplaceholder.typicode.com/posts/"
            accept="image/*"
            class="post-file-upload"
            :on-change="handleLogoImageChange"
            :on-remove="handleFileRemove"
            :auto-upload="false"
            drag
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              Drop file here or
              <em>click to upload</em>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="Survey Logo">
          <el-upload
            action="https://jsonplaceholder.typicode.com/posts/"
            accept="image/*"
            class="post-file-upload"
            :on-change="handleSurveyImageChange"
            :on-remove="handleFileRemove"
            :auto-upload="false"
            drag
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              Drop file here or
              <em>click to upload</em>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="Opt-in Keywords">
          <el-tag
            :key="keyword"
            v-for="keyword in company.optinKeywords"
            closable
            :disable-transitions="false"
            @close="handleClose(company.optinKeywords, keyword)"
          >
            {{ keyword }}
          </el-tag>
          <el-input
            class="input-new-tag"
            v-if="inputVisible.saveOptinInput"
            v-model="inputValue.saveOptinInput"
            ref="saveOptinInput"
            size="mini"
            @keyup.enter.native="handleInputConfirm(company.optinKeywords, 'saveOptinInput')"
            @blur="handleInputConfirm(company.optinKeywords, 'saveOptinInput')"
          >
          </el-input>
          <el-button v-else class="button-new-tag" size="small" @click="showInput('saveOptinInput')"
            >+ New Keyword</el-button
          >
        </el-form-item>
        <el-form-item label="Opt-out Keywords" prop="cume">
          <el-tag
            :key="keyword"
            v-for="keyword in company.optoutKeywords"
            closable
            :disable-transitions="false"
            @close="handleClose(company.optoutKeywords, keyword)"
          >
            {{ keyword }}
          </el-tag>
          <el-input
            class="input-new-tag"
            v-if="inputVisible.saveOptoutInput"
            v-model="inputValue.saveOptoutInput"
            ref="saveOptoutInput"
            size="mini"
            @keyup.enter.native="handleInputConfirm(company.optoutKeywords, 'saveOptoutInput')"
            @blur="handleInputConfirm(company.optoutKeywords, 'saveOptoutInput')"
          >
          </el-input>
          <el-button
            v-else
            class="button-new-tag"
            size="small"
            @click="showInput('saveOptoutInput')"
            >+ New Keyword</el-button
          >
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" @click="dialogVisible = false" plain>Close</el-button>
        <el-button type="primary" :loading="loading" @click="handleUpdateCompany" plain
          >Save</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import updateCompanyMutation from '@/graphql/accounts/updateCompanyMutation.gql';
import allCountriesQuery from '@/graphql/countries/allCountriesQuery.gql';
import countryRegionsQuery from '@/graphql/countries/countryRegionsQuery.gql';
import Can from '@/components/permissions/Can';

export default {
  name: 'CompanyDetail',
  components: {
    Can,
  },
  computed: {
    ...mapState('company', ['timezones', 'loadingTimezones']),
  },
  data: () => ({
    dialogVisible: false,
    logoImage: null,
    surveyImage: null,
    regions: [],
    inputVisible: { saveOptoutInput: false, saveOptinInput: false },
    inputValue: { saveOptinInput: '', saveOptoutInput: '' },
  }),
  props: {
    company: {
      type: Object,
      default: null,
    },
    groups: {
      type: Array,
      default: () => [],
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  apollo: {
    countries: {
      client: 'apiv2',
      query: allCountriesQuery,
      prefetch: true,
    },
  },
  methods: {
    closeDialog() {
      this.dialogVisible = false;
    },
    handleLogoImageChange(file) {
      this.logoImage = file.raw;
    },
    handleSurveyImageChange(file) {
      this.surveyImage = file.raw;
    },
    handleFileRemove() {},
    handleCountryChange(country) {
      this.$apollo
        .query({
          client: 'apiv2',
          query: countryRegionsQuery,
          variables: {
            country,
          },
        })
        .then(({ data }) => {
          this.regions = data.regions;
        });
    },
    handleUpdateCompany() {
      let company = { ...this.company };
      if (this.surveyImage) {
        company = { ...company, surveyImage: this.surveyImage };
      } else {
        delete company.surveyImage;
      }
      if (this.logoImage) {
        company = { ...company, logoImage: this.logoImage };
      } else {
        delete company.logoImage;
      }
      this.$apollo
        .mutate({
          client: 'apiv2',
          mutation: updateCompanyMutation,
          variables: {
            data: company,
          },
        })
        .then(() => {
          this.closeDialog();
        });
    },
    handleClose(keywords, tag) {
      keywords.splice(keywords.indexOf(tag), 1);
    },

    showInput(ref) {
      this.inputVisible[ref] = true;
      this.$nextTick(() => {
        this.$refs[ref].$refs.input.focus();
      });
    },

    handleInputConfirm(keywords, ref) {
      const inputValue = this.inputValue[ref];
      if (inputValue) {
        keywords.push(inputValue);
      }
      this.inputVisible[ref] = false;
      this.inputValue[ref] = '';
    },
  },
  created() {
    this.$parent.$on('closeUpdateCompanyDialog', this.closeDialog);
  },
  mounted() {
    this.$store.dispatch('company/getTimezones');
  },
};
</script>

<style lang="scss" scoped>
.ibox-tool-btn {
  margin-top: -10px;
}
.company-logo {
  text-align: center;
}
.company-logo img {
  max-width: 100%;
}
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
</style>



// WEBPACK FOOTER //
// CompanyDetail.vue?14af256d